export default __webpack_public_path__ + "static/media/05SevenForYao60s.5f64f7ca.mp3";